import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'

import Typography, { FontWeights } from 'builder/styles/typography'
import Button from 'builder/components/Button'

export const BlurredTemplate = styled.img`
  filter: blur(5px);
  border-radius: 8px;
`

export const UnlockContainer = styled.div<{ $height: number; $width: number }>`
  position: absolute;
  top: ${props => props.$height / 2}px;
  transform: translate(-55px, -50%);
  width: ${props => props.$width + 110}px;
  background-color: white;
  padding: ${Spacing.M} 55px;
  border-radius: ${Spacing.XS};
  box-shadow: 0px 0px 1px 0px rgba(15, 56, 113, 0.32), 0px 6px 8px -2px rgba(15, 56, 113, 0.02),
    0px 16px 64px -8px rgba(15, 56, 113, 0.18);
  display: flex;
  align-items: center;
`

export const UnlockText = styled.span`
  color: ${Colors.Neutral90};
  ${FontWeights.Medium};
  ${Typography.Subhead};
`

export const UnlockButton = styled(Button)`
  margin-left: auto;
`

export const TemplateContainer = styled.div`
  position: relative;
`
